import React from 'react';
import { useDispatch } from 'react-redux';
import { updateSelectedPrograms } from '.';

export default function useUpdateSelectedPrograms() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateSelectedPrograms(payload)), [dispatch]);
}